import { useId } from "react";
import { motion, LayoutGroup } from "framer-motion";

/**
 * ProgramSwitcher — schakelt tussen START (12 weken) en VERDER (12 maanden).
 * Zelfde methodiek, andere intensiteit.
 */
export default function ProgramSwitcher({ value, onChange, size = "md", className = "" }) {
  const groupId = useId();
  const options = [
    { key: "start", label: "START", sub: "12 weken" },
    { key: "verder", label: "VERDER", sub: "mogelijk vervolg" },
  ];

  const sizeCls = size === "lg" ? "px-6 py-3 min-w-[140px]" : "px-5 py-2.5 min-w-[120px]";

  return (
    <LayoutGroup id={`program-switcher-${groupId}`}>
      <div
        role="tablist"
        aria-label="Kies programma-variant"
        data-testid="program-switcher"
        className={`inline-flex items-stretch gap-1 p-1 rounded-full border border-ll-ink/20 bg-white/80 backdrop-blur-md ${className}`}
      >
        {options.map((o) => {
          const active = value === o.key;
          return (
            <button
              key={o.key}
              role="tab"
              aria-selected={active}
              data-testid={`program-switch-${o.key}`}
              onClick={() => onChange(o.key)}
              className={`relative rounded-full transition-colors flex flex-col items-center justify-center ${sizeCls} ${
                active ? "text-ll-cream" : "text-ll-ink/80 hover:text-ll-ink"
              }`}
            >
              {active && (
                <motion.span
                  layoutId={`program-pill-${groupId}`}
                  className="absolute inset-0 rounded-full bg-ll-ink"
                  transition={{ type: "spring", stiffness: 350, damping: 32 }}
                />
              )}
              <span className="relative z-10 uppercase tracking-[0.22em] text-xs font-medium">
                {o.label}
              </span>
              <span className="relative z-10 text-[10px] uppercase tracking-[0.2em] opacity-70 mt-0.5">
                {o.sub}
              </span>
            </button>
          );
        })}
      </div>
    </LayoutGroup>
  );
}
